export default __webpack_public_path__ + "static/media/(8).b0d6c35c.jpg";